module.exports = __webpack_public_path__ + "media/A Winter Story.9843e81b.mp3";